module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "characters"
  }, [_c('loader'), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row scroll"
  }, [_c('scroll-progress-bar'), _vm._v(" "), _c('div', {
    staticClass: "col-md-5 col-md-offset-1"
  }, [_c('back-btn'), _vm._v(" "), _vm._m(1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 pull-right"
  }, [_c('div', {
    staticClass: "vertical-list-container"
  }, _vm._l((_vm.dataCharacters.keywords), function(character) {
    return _c('div', {
      staticClass: "vertical-list-wrapper"
    }, [_c('h3', [_c('span', {
      staticClass: "bg"
    }), _vm._v(_vm._s(character.keywords_translations[0].title) + " "), _c('sup', [_vm._v(_vm._s(_vm._f("romanize")(character.keywords_translations[0].id)))])]), _vm._v(" "), _c('ul', _vm._l((character.entities), function(epigram) {
      return _c('li', [_c('router-link', {
        attrs: {
          "to": {
            path: 'epigram',
            params: {
              id: epigram.id
            }
          }
        }
      }, [_vm._v(_vm._s(epigram.title))])], 1)
    }))])
  }))])], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-title-container"
  }, [_c('h1', [_vm._v("Personnages")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-subtitle-container"
  }, [_c('span', {
    staticClass: "dash"
  }), _vm._v(" "), _c('h2', [_vm._v("Les personnages de"), _c('br'), _vm._v(" l'Anthologie Palatine")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9c05ebea"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CharactersComponent.vue
// module id = 108
// module chunks = 0